import React, { useState } from 'react';
import { Row, Col, Card, Form, Button, Spinner } from 'react-bootstrap';
import ApiDataService from '../../services/ApiDataService';

function formatSize(bytes) {
  if (bytes === null || bytes === undefined) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

const FileGrid = ({ entries, onNavigateFolder, onOpenPreview, selected, onToggleSelect }) => {
  const [optimizing, setOptimizing] = useState({});
  const [optimizeResult, setOptimizeResult] = useState({});

  const handleOptimize = (entry, e) => {
    e.stopPropagation();
    setOptimizing(prev => ({ ...prev, [entry.path]: true }));
    const formData = new FormData();
    formData.append('path', entry.path);
    ApiDataService.post('admin/portal/image-optimize/optimize-single', formData).then(response => {
      setOptimizing(prev => ({ ...prev, [entry.path]: false }));
      if (response.data.return_status === "0") {
        const result = response.data.result;
        setOptimizeResult(prev => ({ ...prev, [entry.path]: result }));
      } else {
        setOptimizeResult(prev => ({ ...prev, [entry.path]: { status: 'error', error: response.data.error_message } }));
      }
    }).catch(error => {
      setOptimizing(prev => ({ ...prev, [entry.path]: false }));
      setOptimizeResult(prev => ({ ...prev, [entry.path]: { status: 'error', error: error.message } }));
    });
  };

  return (
    <Row>
      {entries.map(entry => {
        const isFolder = entry.type === 'folder';
        const result = optimizeResult[entry.path];
        return (
          <Col md={3} sm={4} xs={6} key={entry.name} className="mb-3">
            <Card
              onClick={() => isFolder ? onNavigateFolder(entry.name) : onOpenPreview(entry)}
              style={{ cursor: 'pointer' }}
            >
              {!isFolder && (
                <Form.Check
                  type="checkbox"
                  checked={!!selected[entry.path]}
                  onChange={(e) => { e.stopPropagation(); onToggleSelect(entry.path); }}
                  onClick={(e) => e.stopPropagation()}
                  style={{ position: 'absolute', top: 6, left: 6, zIndex: 1 }}
                />
              )}
              {entry.is_image ? (
                <Card.Img variant="top" src={entry.thumbnail_url} style={{ height: 100, objectFit: 'cover' }} />
              ) : (
                <div style={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32 }}>
                  {isFolder ? '📁' : '📄'}
                </div>
              )}
              <Card.Body className="p-2">
                <div style={{ fontSize: 12, wordBreak: 'break-all' }}>{entry.name}</div>
                {!isFolder && <div style={{ fontSize: 11, color: '#888' }}>{formatSize(entry.size)}</div>}
                {entry.is_image && (
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    className="mt-1"
                    disabled={!!optimizing[entry.path]}
                    onClick={(e) => handleOptimize(entry, e)}
                  >
                    {optimizing[entry.path] ? <Spinner animation="border" size="sm" /> : 'Optimize'}
                  </Button>
                )}
                {result && result.status === 'done' && (
                  <div style={{ fontSize: 11, color: 'green' }}>
                    {formatSize(result.original_size)} &rarr; {formatSize(result.new_size)}
                  </div>
                )}
                {result && result.status === 'error' && (
                  <div style={{ fontSize: 11, color: 'red' }}>{result.error}</div>
                )}
              </Card.Body>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};

export default FileGrid;
